<div class="w-full h-full relative">
    <nav class="border-b border-gray-300 w-full bg-white">
        <div class="flex justify-between zuper-dialog-header w-full">
            <div class="primary-font font-bold text-xl text-gray-700 flex items-center pl-2">
                {{'recurring_route.move_route_jobs' | translate}}
            </div>
            <div class="flex justify-around">
                <a class="h-10 w-10 flex justify-center items-center hover:bg-gray-200 rounded-full cursor-pointer"
                    (click)="closeDrawer()">
                    <em class="ti ti-x text-gray-900 text-xl"></em>
                </a>
            </div>
        </div>
    </nav>
    <div class="main-container flex">
        <!-- Source and destination routes segment -->
        <div class="w-1/2 max-w-1/2 bg-white flex items-start border-r p-2 source-route-segment" cdkDropListGroup>
            <!-- Source route -->
            <div class="w-1/2 h-full max-h-full primary-font text-base text-gray-700 font-normal p-2"
                *ngIf="!routePicker.SOURCE.isLoading">
                <!-- Header -->
                <div class="w-full h-full flex flex-col max-h-inherit">
                    <div class="flex items-center justify-between w-full">
                        <span class="text-gray-500">{{'recurring_route.source_route' | translate}}</span>
                        <div class="cursor-pointer underline text-light-blue mr-3"
                            (click)="clearRouteSelection('SOURCE')"
                            *ngIf="routePicker?.SOURCE?.selectedRoute && !routePicker.SOURCE.isDisabled">
                            {{'overall_search.recently_viewed.clear' | translate}}</div>
                    </div>
                    <!-- Route picker -->
                    <div class="border rounded-lg px-4 py-2 my-2 flex items-center gap-1"
                        [ngClass]="routePicker.SOURCE.isDisabled? 'bg-gray-100 cursor-not-allowed': 'cursor-pointer'"
                        [ngxTippy]="!routePicker.SOURCE.isDisabled? routePickerTippyContent: null"
                        [tippyProps]="routePickerTippyProps" (click)="onRoutePickerOpen('SOURCE')">
                        <div *ngIf="routePicker?.SOURCE?.selectedRoute" class="route-picker">
                            <div class="flex-1 font-semibold flex items-center truncate gap-1"
                                *ngIf="routePicker?.SOURCE?.routeNameTwo">
                                <span class="block truncate max-w-3/4"
                                    title="{{routePicker?.SOURCE?.routeNameOne}}">{{routePicker?.SOURCE?.routeNameOne}}</span>
                                <i class="ti ti-arrow-right text-2xl text-gray-500"
                                    *ngIf="routePicker?.SOURCE?.routeNameOne"></i>
                                <span class="block truncate"
                                    title="{{routePicker?.SOURCE?.routeNameTwo}}">{{routePicker?.SOURCE?.routeNameTwo}}</span>
                            </div>
                            <div class="flex-1 font-semibold flex items-center truncate gap-1"
                                *ngIf="!routePicker?.SOURCE?.routeNameTwo">
                                <span class="block truncate max-w-3/4"
                                    title="{{routePicker?.SOURCE?.routeNameOne}}">{{routePicker?.SOURCE?.routeNameOne}}</span>
                            </div>
                        </div>
                        <div class="flex-1 font-semibold flex items-center truncate gap-1"
                            *ngIf="!routePicker?.SOURCE?.selectedRoute">
                            <span class="block truncate max-w-3/4">{{'recurring_route.select_source_route' |
                                translate}}</span>
                        </div>
                        <div class="min-w-fit" *ngIf="!routePicker.SOURCE.isDisabled">
                            <i class="ti font-normal text-2xl text-gray-500"
                                [ngClass]="routePicker?.SOURCE?.tippyRef?.state?.isVisible ? 'ti-chevron-up': 'ti-chevron-down'"></i>
                        </div>
                    </div>
                    <!-- Route details -->
                    <div class="w-full h-full flex flex-col mt-2 rounded-lg border primary-font text-base text-gray-700 font-normal"
                        style="max-height: 90% !important;" *ngIf="routePicker?.SOURCE?.selectedRoute"
                        title="{{routePicker.SOURCE.selectedRoute?.is_locked ? ('recurring_route.unlock_alert' | translate): ''}}">
                        <div class="max-h-1/2 overflow-y-auto zuper-scrollbar">
                            <!-- Header -->
                            <div class="p-4 flex flex-col space-y-2 border-b">
                                <div class="flex items-center justify-between space-x-2">
                                    <div class="flex items-center space-x-2">
                                        <div class="min-w-fit">
                                            <div class="w-4 h-4 rounded-sm"
                                                [ngClass]="{ 'border':routePicker.SOURCE.selectedRoute?.isPrimaryColorWhite }"
                                                [style.backgroundColor]="routePicker?.SOURCE?.selectedRoute?.color">
                                            </div>
                                        </div>
                                        <div class="flex items-center space-x-1">
                                            <i class="ti ti-lock text-2xl text-red-500"
                                                title="{{'dispatchBoard.scheduler.route.locked' | translate}}"
                                                *ngIf="routePicker.SOURCE.selectedRoute?.is_locked"></i>
                                            <span
                                                class="font-medium">{{routePicker.SOURCE.selectedRoute?.route_name}}</span>
                                        </div>
                                    </div>
                                    <button
                                        class="px-2.5 flex-0 py-1.5 flex items-center border primary-font border-gray-300 font-normaltext-base text-gray-700 space-x-1 shadow-sm hover:bg-gray-100 text-base rounded-md bg-white"
                                        *ngIf="routePicker.SOURCE.selectedRoute?.is_locked"
                                        (click)="unLockRoute('SOURCE')">
                                        <i class="ti ti-lock-open text-xl"></i>
                                        <span>{{'text.unlock_route' | translate}}</span>
                                    </button>
                                </div>
                                <div class="flex items-center space-x-2"
                                    *ngIf="routePicker.SOURCE.selectedRoute?.rrText">
                                    <div class="min-w-fit">
                                        <i class="ti ti-repeat text-2xl text-light-blue"></i>
                                    </div>
                                    <div class="flex items-center space-x-1">
                                        <span>{{'text.repeats' | translate}} <span
                                                class="font-semibold">{{routePicker.SOURCE.selectedRoute?.rrText}}</span></span>
                                    </div>
                                </div>
                                <div class="flex items-center"
                                    *ngIf="routePicker.SOURCE.selectedRoute?.assigned_to?.length">
                                    <div *ngFor="let assignedUser of routePicker.SOURCE.selectedRoute?.assigned_to.slice(0, maxAssigedToprofile); let i=index"
                                        class="relative"
                                        [ngStyle]="{'left.px': -i*5, 'z-index': maxAssigedToprofile - i}">
                                        <img *ngIf="assignedUser?.hasValidProfilePicture"
                                            class="h-6 w-6 relative rounded-full ring-2 ring-white" loading="lazy"
                                            src="{{assignedUser?.user?.profile_picture}}" alt=""
                                            title="{{assignedUser?.user?.first_name || ''}} {{assignedUser?.user?.last_name || ''}}">
                                        <div *ngIf="!assignedUser?.hasValidProfilePicture"
                                            title="{{assignedUser?.user?.first_name || ''}} {{assignedUser?.user?.last_name || ''}}"
                                            class="flex items-center justify-center h-6 w-6 ring-2 ring-white rounded-full uppercase bg-gray-200 text-gray-600 font-medium dark:bg-gray-700 dark:text-gray-200 ng-star-inserted">
                                            {{(assignedUser?.user?.first_name || '').slice(0,1)}}
                                        </div>
                                    </div>
                                    <span
                                        *ngIf="routeInstanceDetails?.routeDetails?.assigned_to?.length > maxAssigedToprofile"
                                        class='primary-font relative text-base text-gray-500 ml-2'
                                        [ngStyle]="{'left.px': -maxAssigedToprofile*4}">
                                        + {{routeInstanceDetails?.routeDetails?.assigned_to?.length -
                                        maxAssigedToprofile}}
                                        {{'text.more' | translate}}</span>
                                </div>
                            </div>
                            <!-- Date and Time -->
                            <div
                                class="p-4 flex items-center justify-between space-x-2 border-b primary-font text-base text-gray-700 font-normal">
                                <div class="flex space-x-2 items-center">
                                    <i class="ti ti-calendar text-2xl text-gray-500"></i>
                                    <span
                                        title="{{'text.departure' | translate}}">{{routePicker.SOURCE.selectedRoute?.departureDate}}</span>
                                </div>
                                <span class="text-gray-500"
                                    title="{{'text.departure' | translate}}">{{routePicker.SOURCE.selectedRoute?.startDateTime}}</span>
                            </div>
                        </div>
                        <!-- Route jobs -->
                        <div class="p-4 w-full overflow-y-auto flex-1 zuper-scrollbar move-job-list" cdkDropList
                        [ngClass]="{'bg-gray-50 pointer-events-none': routePicker.SOURCE.selectedRoute?.is_locked}"
                            (cdkDropListEntered)="jobCardDropListEntered($event)"
                            [cdkDropListData]="routePicker.SOURCE.selectedRoute?.jobs" id="sourceJobs"
                            (cdkDropListDropped)="drop($event)">
                            <ol class=" overflow-x-hidden space-y-4 py-2">
                                <!-- Start location -->
                                <li class="relative flex-1"
                                    [ngClass]="!routePicker.SOURCE.selectedRoute?.jobs?.length && !routePicker.SOURCE.selectedRoute?.endLocation ? 'no-trailing-jobs':''">
                                    <div class="flex font-medium w-full">
                                        <div class="min-w-fit flex-0">
                                            <span
                                                class="w-6 h-6 border rounded-full flex justify-center items-center mr-3 z-10 text-sm"
                                                [style.background]="routePicker.SOURCE.selectedRoute?.primaryColor || '#0172CB'">
                                                <i class="ti ti-home text-base"
                                                    [style.color]="routePicker.SOURCE.selectedRoute?.secondaryColor || '#ffffff'"></i>
                                            </span>
                                        </div>
                                        <div
                                            class="flex flex-col primary-font text-base text-gray-700 w-11/12 flex-1 border rounded-lg">
                                            <div class="flex items-center justify-between p-4 border-b">
                                                <span>{{'text.start_location' | translate}}</span>
                                                <i class="ti ti-map text-2xl text-gray-500"
                                                    (click)="navigateToRouteLocation('SOURCE', 'start', 14)"></i>
                                            </div>
                                            <!-- Address -->
                                            <div class="flex flex-col space-y-2 p-4">
                                                <span class="text-gray-500"
                                                    title="{{'text.start_location' | translate}}"
                                                    *ngIf="routePicker.SOURCE.selectedRoute?.startLocation">{{routePicker.SOURCE.selectedRoute?.startLocation}}</span>
                                                <span class="text-gray-700">{{'text.departure' | translate}}:
                                                    {{routePicker.SOURCE.selectedRoute?.departureDateTime}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="flex relative left-10 job-distance-time primary-font text-base font-normal text-gray-500">
                                        <div class="flex items-center space-x-4"
                                            *ngIf="!routeDistanceData.isLoading.SOURCE && (routePicker.SOURCE.selectedRoute?.endLocation || routePicker.SOURCE.selectedRoute?.jobs?.length)">
                                            <div class="flex items-center space-x-1.5"
                                                *ngIf="routeDistanceData.SOURCE?.['SOURCE-START']?.travelDistance">
                                                <i class="ti text-2xl mb-1"
                                                    [ngClass]="modeOfTransportIcon[routePicker.SOURCE.selectedRoute?.transport_mode || 'CAR']"></i>
                                                <span>{{routeDistanceData.SOURCE?.['SOURCE-START']?.travelDistance}}</span>
                                            </div>
                                            <div class="flex items-center"
                                                *ngIf="routeDistanceData.SOURCE?.['SOURCE-START']?.travelTime">
                                                <i class="ti ti-clock text-mid"></i>
                                                <span
                                                    class="ml-mid">{{routeDistanceData.SOURCE?.['SOURCE-START']?.travelTime}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <div class="p-4 flex ml-8 flex-col h-44 items-center justify-center space-y-2 primary-font text-base bg-gray-50 border-2 border-gray-300 border-dotted text-gray-500 w-11/12 flex-1 rounded-lg"
                                    *ngIf="cdkDragConfig.SOURCE.showPlaceHolder">
                                    {{'recurring_route.job_move.placeholder' | translate}}
                                </div>
                                <!-- Job details (n) -->
                                <li class="relative flex-1 group"
                                    [ngClass]="i === routePicker.SOURCE.selectedRoute?.jobs?.length -1 && !routePicker.SOURCE.selectedRoute?.endLocation? 'no-trailing-jobs':''"
                                    *ngFor="let job of routePicker.SOURCE.selectedRoute?.jobs; let i = index;">
                                    <div class="flex font-medium cdk-drag-card" cdkDragBoundary=".source-route-segment"
                                        cdkDrag>
                                        <div class="min-w-fit flex-0">
                                            <span cdkDragHandle
                                                class="w-6 h-6 cursor-grab border rounded-full flex justify-center items-center mr-3 text-sm"
                                                [style.background]="routePicker.SOURCE.selectedRoute?.primaryColor || '#0172CB'">
                                                <span class="text-sm cursor-grab group-hover:hidden"
                                                    [style.color]="routePicker.SOURCE.selectedRoute?.secondaryColor || '#ffffff'">{{i
                                                    +
                                                    1}}</span>
                                                <i class="ti ti-arrows-move cursor-default cursor-grab hidden text-sm group-hover:block"
                                                    [style.color]="routePicker.SOURCE.selectedRoute?.secondaryColor || '#ffffff'"></i>
                                            </span>
                                        </div>
                                        <div class="p-4 flex flex-col space-y-2 primary-font text-base text-gray-700 w-11/12 flex-1 job-card rounded-r-lg"
                                            [ngClass]="{'bg-white': !routePicker.SOURCE.selectedRoute?.is_locked }"
                                            [style.border-left-color]="!routePicker.SOURCE.selectedRoute?.isPrimaryColorWhite ?  routePicker.SOURCE.selectedRoute?.primaryColor : '#0172CB'">
                                            <div class="flex items-center justify-between space-x-2">
                                                <div class="flex items-center space-x-2 truncate">
                                                    <i class="ti ti-repeat text-2xl flex-0 text-light-blue"
                                                        *ngIf="job?.isRecurrence"></i>
                                                    <i class="ti ti-alarm text-2xl flex-0 text-red-700"
                                                        *ngIf="job?.isDelayedJob"></i>
                                                    <span class="block truncate flex-1"
                                                        title="{{job?.job_title}}">{{job?.job_title}}</span>
                                                </div>
                                                <div class="p-0.5 rounded-lg hover:bg-gray-100"
                                                    [matMenuTriggerFor]="jobCardContextMenu"
                                                    [matMenuTriggerData]="{ jobDetails: job, routeSelectionType: 'SOURCE' }">
                                                    <i class="ti ti-dots-vertical text-2xl flex-0"></i>
                                                </div>
                                            </div>
                                            <div class="text-gray-600" *ngIf="job?.startEndTime">{{job?.startEndTime}}</div>
                                            <div *ngIf="job?.isRecurrence && job?.rruleText" class="text-break text-gray-500">{{'text.repeats' | translate}} {{job?.rruleText}}</div>
                                            <div class="flex items-center space-x-2" *ngIf="job?.customerName">
                                                <i class="ti text-light-blue text-lg p-1 rounded-full bg-fade-blue"
                                                    [ngClass]="job?.customerIcon ? job?.customerIcon: 'ti-user'"></i>
                                                <div class="truncate text-gray-600 text-base"
                                                    title="{{job?.customerName}}">{{job?.customerName}}</div>
                                            </div>
                                            <div class="flex items-center space-x-2" *ngIf="job?.customerAddress">
                                                <i
                                                    class="ti ti-map-pin text-light-blue text-lg p-1 rounded-full bg-fade-blue"></i>
                                                <div class="truncate text-gray-600 text-base"
                                                    title="{{job?.customerAddress}}">{{job?.customerAddress}}</div>
                                            </div>
                                            <!-- Conflicts (if any) -->
                                            <div class="p-1 pb-0 primary-font text-base"
                                                *ngIf="(routePicker.SOURCE?.conflicts?.[job?.job_uid || job?.job?.job_uid]?.length) && !routePicker.SOURCE.isConflictLoading">
                                                <div class="flex items-center route-instance-warning">
                                                    <mat-accordion class="w-full zuper-scrollbar">
                                                        <mat-expansion-panel #sourceConflictPanel>
                                                            <mat-expansion-panel-header>
                                                                <mat-panel-title>
                                                                    <div class="w-full flex items-center justify-between text-orange mr-2 space-x-1.5"
                                                                        [ngClass]="sourceConflictPanel.expanded? 'mb-2': ''">
                                                                        <div class="flex items-center space-x-1">
                                                                            <i class="ti ti-alert-triangle text-xl"></i>
                                                                            <span
                                                                                class="text-gary-500 font-normal flex-1 text-orange">
                                                                                <span
                                                                                    class="font-medium">{{routePicker.SOURCE?.conflicts?.[job?.job_uid
                                                                                    || job?.job?.job_uid]?.length}}
                                                                                    {{'text.conflicts'|translate}}</span>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </mat-panel-title>
                                                            </mat-expansion-panel-header>
                                                            <div [ngClass]="!sourceConflictPanel.expanded? 'mt-2': ''">
                                                            </div>
                                                            <div
                                                                *ngFor="let conflict of routePicker.SOURCE?.conflicts[job?.job_uid || job?.job?.job_uid]; let i = index;">
                                                                <div *ngIf="conflict?.message"
                                                                    class="primary-font text-gray-700 text-base font-medium" style="white-space: pre-wrap !important;">{{i+1}}.
                                                                    {{conflict?.message}}</div>
                                                            </div>
                                                        </mat-expansion-panel>
                                                    </mat-accordion>
                                                </div>
                                            </div>
                                            <div *ngIf="routePicker.SOURCE.isConflictLoading"
                                                class="flex justify-start p-1 pb-0">
                                                <lazy-loader class="scale-75"></lazy-loader>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="flex relative left-10 job-distance-time primary-font text-base font-normal text-gray-500">
                                        <div class="flex items-center space-x-4"
                                            *ngIf="!routeDistanceData.isLoading.SOURCE">
                                            <div class="flex items-center space-x-1.5"
                                                *ngIf="routeDistanceData.SOURCE?.[job?.job_uid || job?.job?.job_uid]?.travelDistance">
                                                <i class="ti text-2xl mb-1"
                                                    [ngClass]="modeOfTransportIcon[routePicker.SOURCE.selectedRoute?.transport_mode || 'CAR']"></i>
                                                <span>{{routeDistanceData.SOURCE?.[job?.job_uid ||
                                                    job?.job?.job_uid]?.travelDistance}}</span>
                                            </div>
                                            <div class="flex items-center"
                                                *ngIf="routeDistanceData.SOURCE?.[job?.job_uid || job?.job?.job_uid]?.travelTime">
                                                <i class="ti ti-clock text-mid"></i>
                                                <span class="ml-mid">{{routeDistanceData.SOURCE?.[job?.job_uid ||
                                                    job?.job?.job_uid]?.travelTime}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <!-- End location -->
                                <li class="relative flex-1 end-location"
                                    *ngIf="routePicker.SOURCE.selectedRoute?.endLocation">
                                    <div class="flex font-medium w-full">
                                        <div class="min-w-fit flex-0">
                                            <span
                                                class="w-6 h-6 border rounded-full flex justify-center items-center mr-3 z-10 text-sm"
                                                [style.background]="routePicker.SOURCE.selectedRoute?.primaryColor || '#0172CB'">
                                                <div class="w-2 h-2 text-base"
                                                    [style.background]="routePicker.SOURCE.selectedRoute?.secondaryColor || '#ffffff'">
                                                </div>
                                            </span>
                                        </div>
                                        <div
                                            class="flex flex-col primary-font text-base text-gray-700 w-11/12 flex-1 border rounded-lg">
                                            <div class="flex items-center justify-between p-4 border-b">
                                                <span>{{'text.end_location' | translate}}</span>
                                                <i class="ti ti-map text-2xl text-gray-500"
                                                    (click)="navigateToRouteLocation('SOURCE', 'end', 14)"></i>
                                            </div>
                                            <!-- Address -->
                                            <div class="flex flex-col space-y-2 p-4">
                                                <span
                                                    class="text-gray-500">{{routePicker.SOURCE.selectedRoute?.endLocation}}</span>
                                                <span
                                                    class="text-gray-700">{{'dispatchBoard.scheduler.reschedule.route_end_time'
                                                    | translate}}:
                                                    {{routePicker.SOURCE.selectedRoute?.routeEndDateTime}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>
                    <div class="w-full h-full flex items-center justify-center"
                        *ngIf="!routePicker?.SOURCE?.selectedRoute">
                        {{'recurring_route.select_source_route' | translate}}
                    </div>
                </div>
            </div>
            <div class="w-1/2 h-full primary-font text-base text-gray-700 font-normal p-2 flex items-center justify-center"
                *ngIf="routePicker.SOURCE.isLoading">
                <lazy-loader></lazy-loader>
            </div>
            <!-- Destination route -->
            <div class="w-1/2 h-full max-h-full primary-font text-base text-gray-700 font-normal p-2"
                *ngIf="!routePicker.DESTINATION.isLoading">
                <!-- Header -->
                <div class="w-full h-full flex flex-col max-h-inherit">
                    <div class="flex items-center justify-between w-full">
                        <span class="text-gray-500">{{'recurring_route.destination_route' | translate}}</span>
                        <div class="cursor-pointer underline text-light-blue mr-3"
                            (click)="clearRouteSelection('DESTINATION')"
                            *ngIf="routePicker?.DESTINATION?.selectedRoute">
                            {{'overall_search.recently_viewed.clear' | translate}}</div>
                    </div>
                    <!-- Route picker -->
                    <div class="border rounded-lg px-4 py-2 my-2 flex items-center gap-1 cursor-pointer"
                        [ngxTippy]="routePickerTippyContent" [tippyProps]="routePickerTippyProps"
                        (click)="onRoutePickerOpen('DESTINATION')">
                        <div *ngIf="routePicker?.DESTINATION?.selectedRoute" class="route-picker">
                            <div class="flex-1 font-semibold flex items-center truncate gap-1"
                                *ngIf="routePicker?.DESTINATION?.routeNameTwo">
                                <span class="block truncate max-w-3/4"
                                    title="{{routePicker?.DESTINATION?.routeNameOne}}">{{routePicker?.DESTINATION?.routeNameOne}}</span>
                                <i class="ti ti-arrow-right text-2xl text-gray-500"
                                    *ngIf="routePicker?.DESTINATION?.routeNameOne"></i>
                                <span class="block truncate"
                                    title="{{routePicker?.DESTINATION?.routeNameTwo}}">{{routePicker?.DESTINATION?.routeNameTwo}}</span>
                            </div>
                            <div class="flex-1 font-semibold flex items-center truncate gap-1"
                                *ngIf="!routePicker?.DESTINATION?.routeNameTwo">
                                <span class="block truncate max-w-3/4"
                                    title="{{routePicker?.DESTINATION?.routeNameOne}}">{{routePicker?.DESTINATION?.routeNameOne}}</span>
                            </div>
                        </div>
                        <div class="flex-1 font-semibold flex items-center truncate gap-1"
                            *ngIf="!routePicker?.DESTINATION?.selectedRoute">
                            <span class="block truncate max-w-3/4">{{'recurring_route.select_destination_route' |
                                translate}}</span>
                        </div>
                        <div class="min-w-fit"><i class="ti font-normal text-2xl text-gray-500"
                                [ngClass]="routePicker?.DESTINATION?.tippyRef?.state?.isVisible ? 'ti-chevron-up': 'ti-chevron-down'"></i>
                        </div>
                    </div>
                    <!-- Route details -->
                    <div class="w-full h-full flex flex-col mt-2 rounded-lg border primary-font text-base text-gray-700 font-normal"
                        style="max-height: 90% !important;" *ngIf="routePicker?.DESTINATION?.selectedRoute"
                        title="{{routePicker.DESTINATION.selectedRoute?.is_locked ? ('recurring_route.unlock_alert' | translate): ''}}">
                        <div class="max-h-1/2 overflow-y-auto zuper-scrollbar">
                            <!-- Header -->
                            <div class="p-4 flex flex-col space-y-2 border-b">
                                <div class="flex items-center justify-between">
                                    <div class="flex items-center space-x-2">
                                        <div class="min-w-fit">
                                            <div class="w-4 h-4 rounded-sm"
                                                [ngClass]="{ 'border':routePicker.DESTINATION.selectedRoute?.isPrimaryColorWhite }"
                                                [style.backgroundColor]="routePicker?.DESTINATION?.selectedRoute?.color">
                                            </div>
                                        </div>
                                        <div class="flex items-center space-x-2">
                                            <i class="ti ti-lock text-2xl text-red-500"
                                                title="{{'dispatchBoard.scheduler.route.locked' | translate}}"
                                                *ngIf="routePicker.DESTINATION.selectedRoute?.is_locked"></i>
                                            <span
                                                class="font-medium">{{routePicker.DESTINATION.selectedRoute?.route_name}}</span>
                                        </div>
                                    </div>
                                    <button
                                        class="px-2.5 flex-0 py-1.5 flex items-center border primary-font border-gray-300 font-normal text-gray-700 space-x-1 shadow-sm hover:bg-gray-100 text-base rounded-md bg-white"
                                        *ngIf="routePicker.DESTINATION.selectedRoute?.is_locked"
                                        (click)="unLockRoute('DESTINATION')">
                                        <i class="ti ti-lock-open text-xl"></i>
                                        <span>{{'text.unlock_route' | translate}}</span>
                                    </button>
                                </div>
                                <div class="flex items-center space-x-2"
                                    *ngIf="routePicker.DESTINATION.selectedRoute?.rrText">
                                    <div class="min-w-fit">
                                        <i class="ti ti-repeat text-2xl text-light-blue"></i>
                                    </div>
                                    <div class="flex items-center space-x-1">
                                        <span>{{'text.repeats' | translate}} <span
                                                class="font-semibold">{{routePicker.DESTINATION.selectedRoute?.rrText}}</span></span>
                                    </div>
                                </div>
                                <div class="flex items-center"
                                    *ngIf="routePicker.DESTINATION.selectedRoute?.assigned_to?.length">
                                    <div *ngFor="let assignedUser of routePicker.DESTINATION.selectedRoute?.assigned_to.slice(0, maxAssigedToprofile); let i=index"
                                        class="relative"
                                        [ngStyle]="{'left.px': -i*5, 'z-index': maxAssigedToprofile - i}">
                                        <img *ngIf="assignedUser?.hasValidProfilePicture"
                                            class="h-6 w-6 relative rounded-full ring-2 ring-white" loading="lazy"
                                            src="{{assignedUser?.user?.profile_picture}}" alt=""
                                            title="{{assignedUser?.user?.first_name || ''}} {{assignedUser?.user?.last_name || ''}}">
                                        <div *ngIf="!assignedUser?.hasValidProfilePicture"
                                            title="{{assignedUser?.user?.first_name || ''}} {{assignedUser?.user?.last_name || ''}}"
                                            class="flex items-center justify-center h-6 w-6 ring-2 ring-white rounded-full uppercase bg-gray-200 text-gray-600 font-medium dark:bg-gray-700 dark:text-gray-200 ng-star-inserted">
                                            {{(assignedUser?.user?.first_name || '').slice(0,1)}}
                                        </div>
                                    </div>
                                    <span
                                        *ngIf="routeInstanceDetails?.routeDetails?.assigned_to?.length > maxAssigedToprofile"
                                        class='primary-font relative text-base text-gray-500 ml-2'
                                        [ngStyle]="{'left.px': -maxAssigedToprofile*4}">
                                        + {{routeInstanceDetails?.routeDetails?.assigned_to?.length -
                                        maxAssigedToprofile}}
                                        {{'text.more' | translate}}</span>
                                </div>
                            </div>
                            <!-- Date and Time -->
                            <div
                                class="p-4 flex items-center justify-between space-x-2 border-b primary-font text-base text-gray-700 font-normal">
                                <div class="flex space-x-2 items-center">
                                    <i class="ti ti-calendar text-2xl text-gray-500"></i>
                                    <span
                                        title="{{'text.departure' | translate}}">{{routePicker.DESTINATION.selectedRoute?.departureDate}}</span>
                                </div>
                                <span class="text-gray-500"
                                    title="{{'text.departure' | translate}}">{{routePicker.DESTINATION.selectedRoute?.startDateTime}}</span>
                            </div>
                        </div>
                        <!-- Route jobs -->
                        <div class="p-4 w-full overflow-y-auto flex-1 zuper-scrollbar move-job-list" cdkDropList
                            [ngClass]="{'bg-gray-50 pointer-events-none': routePicker.DESTINATION.selectedRoute?.is_locked}"
                            [cdkDropListData]="routePicker.DESTINATION.selectedRoute?.jobs" id="destinationJobs"
                            (cdkDropListEntered)="jobCardDropListEntered($event)"
                            (cdkDropListDropped)="drop($event)">
                            <ol class="overflow-x-hidden space-y-4 py-2">
                                <!-- Start location -->
                                <li class="relative flex-1"
                                    [ngClass]="!routePicker.DESTINATION.selectedRoute?.jobs?.length && !routePicker.DESTINATION.selectedRoute?.endLocation ? 'no-trailing-jobs':''">
                                    <div class="flex font-medium w-full">
                                        <div class="min-w-fit flex-0">
                                            <span
                                                class="w-6 h-6 border rounded-full flex justify-center items-center mr-3 z-10 text-sm"
                                                [style.background]="routePicker.DESTINATION.selectedRoute?.primaryColor || '#0172CB'">
                                                <i class="ti ti-home text-base"
                                                    [style.color]="routePicker.DESTINATION.selectedRoute?.secondaryColor || '#ffffff'"></i>
                                            </span>
                                        </div>
                                        <div
                                            class="flex flex-col primary-font text-base text-gray-700 w-11/12 flex-1 border rounded-lg">
                                            <div class="flex items-center justify-between p-4 border-b">
                                                <span>{{'text.start_location' | translate}}</span>
                                                <i class="ti ti-map text-2xl text-gray-500"
                                                    (click)="navigateToRouteLocation('DESTINATION', 'start', 14)"></i>
                                            </div>
                                            <!-- Address -->
                                            <div class="flex flex-col space-y-2 p-4">
                                                <span class="text-gray-500"
                                                    title="{{'text.start_location' | translate}}"
                                                    *ngIf="routePicker.DESTINATION.selectedRoute?.startLocation">{{routePicker.DESTINATION.selectedRoute?.startLocation}}</span>
                                                <span class="text-gray-700">{{'text.departure' | translate}}:
                                                    {{routePicker.DESTINATION.selectedRoute?.departureDateTime}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="flex relative left-10 job-distance-time primary-font text-base font-normal text-gray-500">
                                        <div class="flex items-center space-x-4"
                                            *ngIf="!routeDistanceData.isLoading.DESTINATION && (routePicker.DESTINATION.selectedRoute?.endLocation || routePicker.DESTINATION.selectedRoute?.jobs?.length)">
                                            <div class="flex items-center space-x-1.5"
                                                *ngIf="routeDistanceData.DESTINATION?.['DESTINATION-START']?.travelDistance">
                                                <i class="ti text-2xl mb-1"
                                                    [ngClass]="modeOfTransportIcon[routePicker.DESTINATION.selectedRoute?.transport_mode || 'CAR']"></i>
                                                <span>{{routeDistanceData.DESTINATION?.['DESTINATION-START']?.travelDistance}}</span>
                                            </div>
                                            <div class="flex items-center"
                                                *ngIf="routeDistanceData.DESTINATION?.['DESTINATION-START']?.travelTime">
                                                <i class="ti ti-clock text-mid"></i>
                                                <span
                                                    class="ml-mid">{{routeDistanceData.DESTINATION?.['DESTINATION-START']?.travelTime}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <div class="p-4 flex ml-8 flex-col h-44 items-center justify-center space-y-2 primary-font text-base bg-gray-50 border-2 border-gray-300 border-dotted text-gray-500 w-11/12 flex-1 rounded-lg"
                                    *ngIf="cdkDragConfig.DESTINATION.showPlaceHolder">
                                    {{'recurring_route.job_move.placeholder' | translate}}
                                </div>
                                <!-- Job details (n) -->
                                <li class="relative flex-1 group"
                                    [ngClass]="i === routePicker.DESTINATION.selectedRoute?.jobs?.length -1 && !routePicker.DESTINATION.selectedRoute?.endLocation? 'no-trailing-jobs':''"
                                    *ngFor="let job of routePicker.DESTINATION.selectedRoute?.jobs; let i = index;">
                                    <div class="flex font-medium cdk-drag-card" cdkDragBoundary=".source-route-segment"
                                        cdkDrag>
                                        <div class="min-w-fit flex-0">
                                            <span cdkDragHandle
                                                class="w-6 h-6 cursor-grab border rounded-full flex justify-center items-center mr-3 text-sm"
                                                [style.background]="routePicker.DESTINATION.selectedRoute?.primaryColor || '#0172CB'">
                                                <span class="text-sm cursor-grab group-hover:hidden"
                                                    [style.color]="routePicker.DESTINATION.selectedRoute?.secondaryColor || '#ffffff'">{{i
                                                    +
                                                    1}}</span>
                                                <i class="ti ti-arrows-move cursor-default cursor-grab hidden text-sm group-hover:block"
                                                    [style.color]="routePicker.DESTINATION.selectedRoute?.secondaryColor || '#ffffff'"></i>
                                            </span>
                                        </div>
                                        <div class="p-4 flex flex-col space-y-2 primary-font text-base text-gray-700 w-11/12 flex-1 job-card rounded-r-lg"
                                            [ngClass]="{'bg-white': !routePicker.DESTINATION.selectedRoute?.is_locked }"
                                            [style.border-left-color]="!routePicker.DESTINATION.selectedRoute?.isPrimaryColorWhite ?  routePicker.DESTINATION.selectedRoute?.primaryColor : '#0172CB'">
                                            <div class="flex items-center justify-between space-x-1">
                                                <div class="flex items-center space-x-2 truncate">
                                                    <i class="ti ti-repeat text-2xl flex-0 text-light-blue"
                                                        *ngIf="job?.isRecurrence"></i>
                                                    <i class="ti ti-alarm text-2xl flex-0 text-red-700"
                                                        *ngIf="job?.isDelayedJob"></i>
                                                    <span class="block truncate flex-1"
                                                        title="{{job?.job_title}}">{{job?.job_title}}</span>
                                                </div>
                                                <div class="p-0.5 rounded-lg hover:bg-gray-100"
                                                    [matMenuTriggerFor]="jobCardContextMenu"
                                                    [matMenuTriggerData]="{ jobDetails: job, routeSelectionType: 'DESTINATION' }">
                                                    <i class="ti ti-dots-vertical text-2xl flex-0"></i>
                                                </div>
                                            </div>
                                            <div class="text-gray-500" *ngIf="job?.startEndTime">{{job?.startEndTime}}</div>
                                            <div *ngIf="job?.isRecurrence && job?.rruleText" class="text-break text-gray-500">{{'text.repeats' | translate}} {{job?.rruleText}}</div>
                                            <div class="flex items-center space-x-2">
                                                <i class="ti text-light-blue text-lg p-1 rounded-full bg-fade-blue"
                                                    [ngClass]="job?.customerIcon ? job?.customerIcon: 'ti-user'"></i>
                                                <div class="truncate text-gray-600 text-base"
                                                    title="{{job?.customerName}}">{{job?.customerName}}</div>
                                            </div>
                                            <div class="flex items-center space-x-2">
                                                <i
                                                    class="ti ti-map-pin text-light-blue text-lg p-1 rounded-full bg-fade-blue"></i>
                                                <div class="truncate text-gray-600 text-base"
                                                    title="{{job?.customerAddress}}">{{job?.customerAddress}}</div>
                                            </div>
                                            <!-- Conflicts (if any) -->
                                            <div class="p-1 pb-0 primary-font text-base"
                                                *ngIf="(routePicker.DESTINATION.conflicts?.[job?.job_uid || job?.job?.job_uid]?.length) && !routePicker.DESTINATION.isConflictLoading">
                                                <div class="flex items-center route-instance-warning">
                                                    <mat-accordion class="w-full zuper-scrollbar">
                                                        <mat-expansion-panel #destinationConflictPanel>
                                                            <mat-expansion-panel-header>
                                                                <mat-panel-title>
                                                                    <div class="w-full flex items-center justify-between text-orange mr-2 space-x-1.5"
                                                                        [ngClass]="destinationConflictPanel.expanded? 'mb-2': ''">
                                                                        <div class="flex items-center space-x-1">
                                                                            <i class="ti ti-alert-triangle text-xl"></i>
                                                                            <span
                                                                                class="text-gary-500 font-normal flex-1 text-orange">
                                                                                <span
                                                                                    class="font-medium">{{routePicker.DESTINATION?.conflicts?.[job?.job_uid
                                                                                    || job?.job?.job_uid]?.length}}
                                                                                    {{'text.conflicts'|translate}}</span>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </mat-panel-title>
                                                            </mat-expansion-panel-header>
                                                            <div
                                                                [ngClass]="!destinationConflictPanel.expanded? 'mt-2': ''">
                                                            </div>
                                                            <div
                                                                *ngFor="let conflict of routePicker.DESTINATION?.conflicts[job?.job_uid || job?.job?.job_uid]; let i = index;">
                                                                <span *ngIf="conflict?.message"
                                                                    class="primary-font text-gray-700 text-base font-medium">{{i+1}}.
                                                                    {{conflict?.message}}</span>
                                                            </div>
                                                        </mat-expansion-panel>
                                                    </mat-accordion>
                                                </div>
                                            </div>
                                            <div *ngIf="routePicker.DESTINATION.isConflictLoading"
                                                class="flex justify-start p-1 pb-0">
                                                <lazy-loader class="scale-75"></lazy-loader>
                                            </div>
                                        </div>
                                    </div>
                                    <div
                                        class="flex relative left-10 job-distance-time primary-font text-base font-normal text-gray-500">
                                        <div class="flex items-center space-x-4"
                                            *ngIf="!routeDistanceData.isLoading.DESTINATION">
                                            <div class="flex items-center space-x-1.5"
                                                *ngIf="routeDistanceData.DESTINATION?.[job?.job_uid || job?.job?.job_uid]?.travelDistance">
                                                <i class="ti text-2xl mb-1"
                                                    [ngClass]="modeOfTransportIcon[routePicker.DESTINATION.selectedRoute?.transport_mode || 'CAR']"></i>
                                                <span>{{routeDistanceData.DESTINATION?.[job?.job_uid ||
                                                    job?.job?.job_uid]?.travelDistance}}</span>
                                            </div>
                                            <div class="flex items-center"
                                                *ngIf="routeDistanceData.DESTINATION?.[job?.job_uid || job?.job?.job_uid]?.travelTime">
                                                <i class="ti ti-clock text-mid"></i>
                                                <span class="ml-mid">{{routeDistanceData.DESTINATION?.[job?.job_uid ||
                                                    job?.job?.job_uid]?.travelTime}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <!-- End location -->
                                <li class="relative flex-1 end-location"
                                    *ngIf="routePicker.DESTINATION.selectedRoute?.endLocation">
                                    <div class="flex font-medium w-full">
                                        <div class="min-w-fit flex-0">
                                            <span
                                                class="w-6 h-6 border rounded-full flex justify-center items-center mr-3 z-10 text-sm"
                                                [style.background]="routePicker.DESTINATION.selectedRoute?.primaryColor || '#0172CB'">
                                                <div class="w-2 h-2 text-base"
                                                    [style.background]="routePicker.DESTINATION.selectedRoute?.secondaryColor || '#ffffff'">
                                                </div>
                                            </span>
                                        </div>
                                        <div
                                            class="flex flex-col primary-font text-base text-gray-700 w-11/12 flex-1 border rounded-lg">
                                            <div class="flex items-center justify-between p-4 border-b">
                                                <span>{{'text.end_location' | translate}}</span>
                                                <i class="ti ti-map text-2xl text-gray-500"
                                                    (click)="navigateToRouteLocation('DESTINATION', 'end', 14)"></i>
                                            </div>
                                            <!-- Address -->
                                            <div class="flex flex-col space-y-2 p-4">
                                                <span
                                                    class="text-gray-500">{{routePicker.DESTINATION.selectedRoute?.endLocation}}</span>
                                                <span
                                                    class="text-gray-700">{{'dispatchBoard.scheduler.reschedule.route_end_time'
                                                    | translate}}:
                                                    {{routePicker.DESTINATION.selectedRoute?.routeEndDateTime}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ol>
                        </div>
                    </div>
                    <div class="w-full h-full flex items-center justify-center"
                        *ngIf="!routePicker?.DESTINATION?.selectedRoute">
                        {{'recurring_route.select_destination_route' | translate}}
                    </div>
                </div>
            </div>
            <div class="w-1/2 h-full primary-font text-base text-gray-700 font-normal p-2 flex items-center justify-center"
                *ngIf="routePicker.DESTINATION.isLoading">
                <lazy-loader></lazy-loader>
            </div>
        </div>
        <!-- Tabs -->
        <div class="w-1/2 bg-white">
            <!-- Navbar -->
            <div class="flex items-center justify-between border-b">
                <Tabs [tabs]="destinationSelectorNavTabs" [config]="destinationSelectorNavTabConfig"
                    [currentActiveTab]="selectedNavTab" (selectedTab)="onDestinationSelectorNavTabChange($event)">
                </Tabs>
                <div class="flex items-center space-x-2 min-w-max">
                    <div class="h-10 relative flex items-center rounded-md bg-white border primary-font font-base font-normal"
                        *ngIf="showAllRoutes">
                        <button type="button" (click)="schedulerDateIncrement('prev')"
                            [ngClass]="routeFilters?.disableDateButton?.prev ? 'cursor-default': ''"
                            [disabled]="routeFilters?.disableDateButton?.prev"
                            class="flex items-center border-r justify-center rounded-l-md py-2 pl-3 pr-4 text-gray-400 focus:relative md:w-9 md:px-2 hover:bg-gray-100 hover:text-gray-900 rounded-lg h-10 rounded-r-none">
                            <i class="ti ti-chevron-left text-2xl cursor-default"></i>
                        </button>
                        <div class="flex items-center">
                            <input readonly [matDatepicker]="schedulerDatepicker" [datePickerFormat]="dateFormat"
                                [(ngModel)]="routeFilters.date" [min]="today"
                                class="block w-26 pt-0.5 text-base ml-2 px-0.5 bg-white cursor-pointer font-medium"
                                placeholder="{{'text.choose_date.header' | translate}}"
                                (dateChange)="onSchedulerDateChange()" (click)="schedulerDatepicker.open()">
                            <mat-datepicker #schedulerDatepicker [dateClass]="recurringRouteService.routeDatePickerDateClass"></mat-datepicker>
                        </div>
                        <button type="button" (click)="schedulerDateIncrement('next')"
                            [disabled]="routeFilters?.disableDateButton?.next"
                            class="flex items-center border-l justify-center rounded-r-md py-2 pl-4 pr-3 text-gray-400 focus:relative md:w-9 md:px-2 hover:bg-gray-100 hover:text-gray-900 rounded-lg h-10 rounded-l-none">
                            <i class="ti ti-chevron-right text-2xl"></i>
                        </button>
                    </div>
                    <div class="h-10 relative flex items-center rounded-md bg-white primary-font font-base font-normal border px-2 cursor-pointer"
                        *ngIf="showAllRoutes">
                        <div class="flex items-center" [ngxTippy]="routeFilterTippyContent"
                            [tippyProps]="filterTippyProps">
                            <i class="ti ti-filter text-2xl mr-1 text-gray-500"></i>
                            <span>{{'filter.label' | translate}}</span>
                            <badge *ngIf="filterTippyData?.totalFilter" class="ml-1.5" [options]="updateFilterCount()">
                            </badge>
                        </div>
                        <i class="ti text-2xl ml-2 text-gray-500"
                            [ngClass]="filterTippyData?.isOpened ? 'ti-chevron-up': 'ti-chevron-down'"></i>
                    </div>
                    <!-- Toggle -->
                    <div class="show-routes-toggle flex items-center pr-6">
                        <label class="show-routes-toggle-container">
                            <input type="checkbox" [(ngModel)]="showAllRoutes" (click)="!(selectedNavTab === 'SCHEDULER' && showAllRoutes) && onToggleShowAllRoutes()">
                            <div class="show-routes-toggle-slider"
                            [ngClass]="selectedNavTab === 'SCHEDULER'? 'cursor-not-allowed': ''"></div>
                        </label>
                        <div class="text-base primary-font font-normal mx-2">{{'recurring_route.move.show_all_routes' |
                            translate}}</div>
                    </div>

                </div>
            </div>
            <!-- Content -->
             <div class="second-container border-b">
                 <div [hidden]="selectedNavTab !== 'MAP'" class="w-full h-full move-map">
                     <div id="move-map-container" class="w-full h-full">
                         <div class="ml-2 absolute bottom-2 tile-layer-parent">
                             <span
                                 class="w-12 h-12 tile-layer-satellite cursor-pointer border-2 border-gray-500 shadow-md rounded-md"
                                 *ngIf="currentTitleType === 'DEFAULT'" title="{{'satellite.view' | translate}}"
                                 (click)="setTileLayer('SATELLITE', $event)"></span>
                             <span
                                 class="w-12 h-12 tile-layer-default cursor-pointer border-2 border-gray-500 shadow-md rounded-md"
                                 *ngIf="currentTitleType === 'SATELLITE'" title="{{'map.view' | translate}}"
                                 (click)="setTileLayer('DEFAULT', $event)"></span>
                         </div>
                     </div>
                 </div>
                 <div [hidden]="selectedNavTab !== 'SCHEDULER'" class="w-full h-full">
                     <bryntum-scheduler-pro #moveRouteScheduler id="moveRouteScheduler" [barMargin]="5"
                           [columns]="schedulerProConfig?.columns || []" [eventRenderer]="schedulerProConfig?.eventRenderer"
                           [startDate]="schedulerProConfig?.startDate" [endDate]="schedulerProConfig?.endDate"
                           [resources]="schedulerProConfig?.resources" [timeZone]="timezone"
                           [assignments]="schedulerProConfig?.assignments" [presets]="schedulerProConfig?.presets"
                           [config]="schedulerProConfig" ></bryntum-scheduler-pro>
                 </div>
             </div>
        </div>
    </div>

    <!-- Footer -->
    <div class="flex justify-between items-center border-t border-gray-300 zuper-dialog-footer bg-white">
        <div class="flex justify-around space-x-4">
            <button type="button" (click)="resetAllMoveChanges()" *ngIf="isRouteJobChanged"
                class="px-6 items-center py-2 border b-1 border-gray-300 text-black shadow-sm text-lg font-small rounded-md  bg-white focus:outline-none btn-small">
                {{'recurring_route.move.reset_all_changes' | translate}}</button>
        </div>
        <div class="primary-font text-base font-medium text-gray-700" *ngIf="isRouteJobChanged">
            <div class="flex items-center space-x-2" *ngIf="!isEligibleForSeriesMovement">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="gray"
                stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="icon icon-tabler icons-tabler-outline icon-tabler-repeat-once">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3" />
                <path d="M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3" />
                <path d="M11 11l1 -1v4" />
                </svg>
                <span>{{'recurring_route.move.eligibility.one_instances.title' | translate}}</span>
                <div class="cursor-pointer"
                    [matTooltip]="infoBubbleText.ONE_INSTNACE"
                    matTooltipPosition="above" matTooltipClass="move-info-tooltip" >
                   <i class="ti ti-info-circle text-gray-700 text-3xl"></i>
                </div>
            </div>
            <div class="flex items-center space-x-2" *ngIf="isEligibleForSeriesMovement">
                <i class="ti ti-repeat text-light-blue text-2xl"></i>
                <span>{{'recurring_route.move.eligibility.all_instances.title' | translate}}</span>
                <div class="cursor-pointer"
                [matTooltip]="infoBubbleText.ALL_INSTNACE"
                matTooltipPosition="above" matTooltipClass="move-info-tooltip" >
                   <i class="ti ti-info-circle text-gray-700 text-3xl"></i>
                </div>
            </div>
        </div>
        <div class="flex justify-around space-x-4">
            <button type="button" (click)="closeDrawer()"
                class="px-6 items-center py-2 border b-1 border-gray-300 text-black shadow-sm text-lg font-small rounded-md  bg-white focus:outline-none btn-small">
                {{'cancel.text' | translate}}</button>
            <button type="submit"
                (click)="isRouteJobChanged && moveDialogSubmit()"
                [ngClass]="!isRouteJobChanged? 'opacity-75 cursor-not-allowed default-hover': ''"
                [disabled]="isRouteMoveInProgress"
                class="bg-primary px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white font-small rounded-md text-white-600 focus:outline-none btn-small"
                type="submit">{{'text.save' | translate}}</button>
        </div>
    </div>
</div>

<ng-template let-hide #routePickerTippyContent>
    <route-picker [extraClass]="'w-120 h-128'"
        [routeUid]="routeSelectionType? routePicker[routeSelectionType === 'SOURCE'? 'DESTINATION': 'SOURCE'].selectedRoute?.route_uid: null"
        [recurringRouteMasterUid]="routeSelectionType? routePicker[routeSelectionType === 'SOURCE'? 'DESTINATION': 'SOURCE'].selectedRoute?.['recurring_route']?.recurring_route_uid: null"
        [timezone]="timezone"
        (actionEmitter)="routePickerEventEmitter($event)"></route-picker>
</ng-template>

<!-- Filter template -->
<ng-template let-hide #routeFilterTippyContent>
    <div class="w-90 h-auto text-base font-normal primary-font text-gray-700">
        <div class="p-3 border-b flex justify-between">
            <span>{{'filter.label' | translate}}</span>
            <span class="underline text-light-blue cursor-pointer"
                (click)="clearFilter()">{{'overall_search.recently_viewed.clear' | translate}}</span>
        </div>
        <!-- Skillset -->
        <div class="p-3 border-b">
            <label class="block text-base mb-2 font-medium text-gray-600">
                {{'dispatchBoard.settings.employee.more_information.skillset' | translate}}
            </label>
            <ng-select class="skills-filter" [items]="routeFilters.skills.data" bindLabel="skillset_name"
                bindValue="skillset_uid" [multiple]="true" [searchable]="true" appendTo="body"
                [loading]="routeFilters.skills.isLoading"
                placeholder="{{'dispatch.filter.skills.placeholder' | translate}}"
                [(ngModel)]="routeFilters.skills.selectedSkills" [hideSelected]="false" [closeOnSelect]="false">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <div class="primary-font text-base flex items-center">
                        <input id="item-{{index}}" type="checkbox" class="mr-2" [checked]="item$.selected"
                            (change)="$event.stopPropagation()" />
                        {{item.skillset_name}}
                    </div>
                </ng-template>
            </ng-select>
        </div>
        <!-- Users -->
        <div class="p-3">
            <label class="block text-base mb-2 font-medium text-gray-600">
                {{'text.users' | translate}}
            </label>
            <ng-select [items]="routeFilters.users.data" bindLabel="name" class="users-filter"
                [loading]="routeFilters.users.isLoading" (open)="onUserFilterSelectOpen()" bindValue="user_uid"
                [multiple]="true" [searchable]="true" appendTo="body" (scrollToEnd)="onEmployeeScrollToEnd()"
                [loading]="routeFilters.users.isLoading" placeholder="{{'text.select_users' | translate}}"
                [typeahead]="employeeValueSubject" [(ngModel)]="routeFilters.users.selectedUsers" [hideSelected]="false"
                [closeOnSelect]="false">
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                    <div class="primary-font text-base flex items-center">
                        <input id="item-{{index}}" type="checkbox" class="mr-4" [checked]="item$.selected"
                            (change)="$event.stopPropagation()" />
                        <div class="primary-font text-base text-gray-600">
                            <p class="font-semibold">
                                {{item?.name || ''}}
                            </p>
                        </div>
                    </div>
                </ng-template>
            </ng-select>
        </div>
        <footer>
            <div class="flex justify-end space-x-4 p-3 pt-2">
                <button type="button" (click)="onFilterCancel()"
                    class="px-6 text-base font-normal primary-font items-center py-2 border b-1 border-gray-300 text-black shadow-sm rounded-md bg-white focus:outline-none btn-small">
                    {{'cancel.text' | translate}}</button>
                <button type="submit" (click)="onFilterApply()"
                    class="bg-primary text-base font-normal primary-font px-6 items-center py-2 border b-1 border-gray-300 shadow-sm text-white font-small rounded-md text-white-600 focus:outline-none btn-small"
                    type="submit">{{'text.apply' | translate}}</button>
            </div>
        </footer>
    </div>
</ng-template>

<mat-menu #jobCardContextMenu="matMenu" class="job-card-context-menu">
    <ng-template matMenuContent let-jobDetails="jobDetails" let-routeSelectionType="routeSelectionType">
        <div mat-menu-item
            class="cursor-pointer text-gray-700 primary-font text-base font-normal flex items-center h-12"
            (click)="jobCardContextMenuAction('SHOW_IN_MAP', jobDetails, routeSelectionType)">
            <i class="ti ti-map-2 text-2xl mr-1.5"></i>
            <span>{{'dispatchBoard.scheduler.event_menu.options.show_on_map' | translate}}</span>
        </div>
        <div mat-menu-item class="cursor-pointer text-red-600 primary-font text-base font-normal flex items-center h-12"
            (click)="jobCardContextMenuAction('REMOVE_JOB', jobDetails, routeSelectionType)">
            <i class="ti ti-map-minus text-2xl mr-1.5"></i>
            <span>{{'alert.confirm.remove_job' | translate}}</span>
        </div>
    </ng-template>
</mat-menu>

<!-- Movement confirmation dialog content -->
<ng-template #moveConfirmationDialogContent let-hide let-data>
    <div mat-dialog-title
        class="primary-font font-semibold text-base mb-0 text-gray-700 flex justify-between border-b border-b-gray-300 zuper-dialog-header">
        <h2>{{'route.edit' | translate}} - {{data?.sourceRoute?.route_name || ''}}</h2>
        <button mat-icon-button aria-label="close dialog" (click)="closeMoveConfirmationDialog()" tabindex="-1">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div
        class="w-full h-full overflow-y-auto zuper-scrollbar primary-font font-normal text-base text-gray-700">
        <div class="relative overflow-y-auto flex flex-col space-y-4 p-4">
            <!-- Only this instance -->
            <div class="flex items-start space-x-3">
                <input id="one-instance" type="radio" [value]="ONE_INSTNACE"
                    [checked]="moveConfirmationDialogData.selectedMovementType === 'ONE_INSTNACE'"
                    (click)="moveConfirmationDialogData.selectedMovementType = 'ONE_INSTNACE'"
                    class="h-4 w-4 mt-0.5 border-gray-300 text-indigo-600">
                <label for="one-instance" class="flex flex-col space-y-1 cursor-pointer">
                    <span class="font-medium text-gray-700">{{'recurring_route.job_move.instance_only_title' |
                        translate}}</span>
                    <span class="font-normal text-gray-500">{{'recurring_route.job_move.instance_only_subtitle' |
                        translate}} </span>
                </label>
            </div>

            <!-- All instances -->
            <div class="flex items-start space-x-3">
                <input id="all-instance" type="radio" [value]="ALL_INSTNACE"
                    [checked]="moveConfirmationDialogData.selectedMovementType === 'ALL_INSTNACE'"
                    (click)="moveConfirmationDialogData.selectedMovementType = 'ALL_INSTNACE'"
                    class="h-4 w-4 mt-0.5 border-gray-300 text-indigo-600">
                <label for="all-instance" class="flex flex-col space-y-1 cursor-pointer">
                    <span class="font-medium text-gray-700">{{'recurring_route.job_move.all_instances_title' |
                        translate}}</span>
                    <span class="font-normal text-gray-500">{{'recurring_route.job_move.all_instances_subtitle' |
                        translate}}</span>
                </label>
            </div>

            <div class="flex flex-col space-y-4" *ngIf="data?.summary?.deletedSourceJobs?.length || data?.summary?.deletedDestinationJobs?.length 
                || data?.summary?.movedSourceJobs?.length || data?.summary?.movedDestinationJobs?.length">
                <span class="font-semibold">{{'reports.details.routes.summary' | translate}}</span>
                <div class="max-h-64 overflow-y-auto zuper-scrollbar flex flex-col space-y-4">
                    <!-- Source summary -->
                    <div class="text-base font-normal primary-font text-gray-700 flex flex-col space-y-1.5"
                        *ngIf="data?.summary?.deletedSourceJobs?.length || data?.summary?.movedSourceJobs?.length">
                        <span class="font-medium">{{'recurring_route.source_route' | translate}} :
                            {{data?.sourceRoute?.route_name || ''}} ({{data?.sourceRoute?.departureDateTime ||
                            ''}})</span>
                        <!-- Moved Jobs -->
                        <div class="ml-3 flex flex-col space-y-2">
                            <div class="flex items-center space-x-1.5"
                                *ngFor="let sourceMovedJob of data?.summary?.movedSourceJobs">
                                <span class="h-2 w-2 rounded-full mb-1 bg-gray-700"></span>
                                <span>{{sourceMovedJob?.job_title || ''}}</span>
                                <badge [options]="{ type: 'COMPLETED', displayKey: 'text.moved', displayName: 'Moved'}">
                                </badge>
                                <div class="cursor-pointer"
                                    [matTooltip]="data?.sourceRoute?.route_name + ' (' +  data?.sourceRoute?.departureDateTime + ') ' + '-> ' + data?.destinationRoute?.route_name + ' (' + data?.destinationRoute?.departureDateTime + ') '"
                                    matTooltipPosition="right" matTooltipClass="move-info-tooltip">
                                    <i class="ti ti-info-circle text-gray-700 text-3xl"></i>
                                </div>
                            </div>
                            <!-- Removed Jobs -->
                            <div class="flex items-center space-x-1.5"
                                *ngFor="let sourceDeletedJob of data?.summary?.deletedSourceJobs">
                                <span class="h-2 w-2 rounded-full mb-1 bg-gray-700"></span>
                                <span class="line-through">{{sourceDeletedJob?.job_title || ''}}</span>
                                <badge
                                    [options]="{ type: 'REMOVED', displayKey: 'text.removed', displayName: 'Removed'}">
                                </badge>
                            </div>
                        </div>
                    </div>
                    <!-- Destination summary -->
                    <div class="text-base font-normal primary-font text-gray-700 flex flex-col space-y-1.5"
                        *ngIf="data?.summary?.deletedDestinationJobs?.length || data?.summary?.movedDestinationJobs?.length">
                        <span class="font-medium">{{'recurring_route.destination_route' | translate}} :
                            {{data?.destinationRoute?.route_name || ''}} ({{data?.destinationRoute?.departureDateTime ||
                            ''}})</span>
                        <!-- Moved Jobs -->
                        <div class="ml-3 flex flex-col space-y-2">
                            <div class="flex items-center space-x-1.5"
                                *ngFor="let destinationMovedJob of data?.summary?.movedDestinationJobs">
                                <span class="h-2 w-2 rounded-full mb-1 bg-gray-700"></span>
                                <span>{{destinationMovedJob?.job_title || ''}}</span>
                                <badge [options]="{ type: 'COMPLETED', displayKey: 'text.moved', displayName: 'Moved'}">
                                </badge>
                                <div class="cursor-pointer"
                                    [matTooltip]=" data?.destinationRoute?.route_name + ' (' + data?.destinationRoute?.departureDateTime + ') ' + '-> ' + data?.sourceRoute?.route_name + ' (' +  data?.sourceRoute?.departureDateTime + ') '"
                                    matTooltipPosition="right" matTooltipClass="move-info-tooltip">
                                    <i class="ti ti-info-circle text-gray-700 text-3xl"></i>
                                </div>
                            </div>
                            <!-- Removed Jobs -->
                            <div class="flex items-center space-x-1.5"
                                *ngFor="let destinationDeletedJob of data?.summary?.deletedDestinationJobs">
                                <span class="h-2 w-2 rounded-full mb-1 bg-gray-700"></span>
                                <span class="line-through">{{destinationDeletedJob?.job_title || ''}}</span>
                                <badge
                                    [options]="{ type: 'REMOVED', displayKey: 'text.removed', displayName: 'Removed'}">
                                </badge>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div
        class="flex justify-end border-t border-gray-300 zuper-dialog-footer primary-font font-normal text-base text-gray-700">
        <div class="flex justify-around space-x-4">
            <button type="button" (click)="closeMoveConfirmationDialog()" [disabled]="isRouteMoveInProgress"
                class="px-6 items-center py-2 border b-1 border-gray-300 text-black shadow-sm text-lg font-small rounded-md bg-white focus:outline-none btn-small">
                {{'close.text' | translate}}</button>
            <button (click)="onMoveComplete()"
                class="flex min-w-24 btn-small px-6 items-center py-2 border text-base b-1 shadow-sm text-white font-medium rounded-md text-white-600 focus:outline-none bg-primary">
                <span class="text-white">{{'proceed' | translate}}</span>
            </button>
        </div>
    </div>
</ng-template>